<template>
  <div class="ContratosNuevo">
    <md-layout md-gutter="24" md-align="center" md-flex="100" class="m-t-24">
      <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="100" md-flex-large="30" md-flex-xlarge="20">
        <div v-if="contrato.tipo_cnt === 'laboral_guardia' || contrato.tipo_cnt === null">
          Para que el sistema automáticamente llene el contrato con la información del empleado deberá de poner entre una llaves { } los siguientes campos:
          <ul>
            <li>nombre_empleado</li>
            <li>ape_paterno_empleado</li>
            <li>ape_materno_empleado</li>
            <li>fecha_nacimiento_empleado</li>
            <li>domicilio_empleado</li>
          </ul>
        </div>
        <div v-if="contrato.tipo_cnt === 'servicios_monitoreo' || contrato.tipo_cnt === 'servicios_guardias'">
          Para que el sistema automáticamente llene el contrato con la información de la empresa deberá de poner entre una llaves { } los siguientes campos:
          <ul>
            <li>razon_social_cliente</li>
            <li>rfc_cliente</li>
            <li>email_cliente</li>
            <li>telefono_cliente</li>
            <li>domicilio_cliente</li>
          </ul>
        </div>
      </md-layout>
      <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="100" md-flex-large="70" md-flex-xlarge="70">
        <md-card class="w-100">
          <md-card-header>
            <div class="md-title">Nuevo contrato</div>
          </md-card-header>
          <md-card-content>
          </md-card-content>
          <md-card-content>
            <md-layout md-gutter="24" md-align="center" md-flex="100">
              <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-medium="50" md-flex-large="60" md-flex-xlarge="20">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_titulo }">
                  <label>Nombre del contrato</label>
                  <md-input required v-model="contrato.titulo_cnt"></md-input>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="25" md-flex-large="20" md-flex-xlarge="20">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_tipo }">
                  <label for="tipo_cnt">Tipo</label>
                  <md-select name="tipo_cnt" id="tipo_cnt" required v-model="contrato.tipo_cnt">
                    <md-option value="laboral_guardia">Contrato laboral guardia</md-option>
                    <md-option value="servicios_monitoreo">Prestación servicios monitoreo</md-option>
                    <md-option value="servicios_guardias">Prestación servicios guardias</md-option>
                  </md-select>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="100" md-flex-small="50" md-flex-medium="25" md-flex-large="20" md-flex-xlarge="20">
                <md-input-container v-bind:class="{ 'md-input-invalid': val.v_duracion }">
                  <label for="duracion_cnt">Duración</label>
                  <md-select name="duracion_cnt" id="duracion_cnt" required v-model="contrato.duracion_cnt">
                    <md-option value="indeterminado">Indeterminado</md-option>
                    <md-option value="1">1 mes</md-option>
                    <md-option value="2">2 meses</md-option>
                    <md-option value="3">3 meses</md-option>
                    <md-option value="4">4 meses</md-option>
                    <md-option value="5">5 meses</md-option>
                    <md-option value="6">6 meses</md-option>
                    <md-option value="7">7 meses</md-option>
                    <md-option value="8">8 meses</md-option>
                    <md-option value="9">9 meses</md-option>
                    <md-option value="10">10 meses</md-option>
                    <md-option value="11">11 meses</md-option>
                    <md-option value="12">12 meses</md-option>
                  </md-select>
                </md-input-container>
              </md-layout>
              <md-layout md-flex-xsmall="100" md-flex-small="100" md-flex-large="100" md-flex-xlarge="100">
                <wysiwyg style="background:white!important" v-model="contrato.contenido_cnt"> </wysiwyg>
              </md-layout>
            </md-layout>
          </md-card-content>
          <md-card-actions>
            <router-link tag="md-button" to="/contratos">Cancelar</router-link>
            <md-button class="md-raised md-primary" @click.native="guardarContrato()">Guardar</md-button>
          </md-card-actions>
        </md-card>
      </md-layout>
    </md-layout>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import md5 from "blueimp-md5";
import Snackbar from "node-snackbar";
export default {
  name: "ContratosNuevo",
  methods: {
    guardarContrato() {
      if (this.validarCamposContrato()) {
        this.$http
          .post("contratos/guardar", {
            token: this.$session.get("token"),
            data: this.contrato
          })
          .then(
            response => {
              if (response.status === 200 && "msg" in response.body) {
                Snackbar.show({
                  text: response.body.msg,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false
                });
                this.$router.push({ name: "ContratosListado" });
              } else {
                Snackbar.show({
                  text: response.body.error,
                  actionText: "Cerrar",
                  pos: "top-right",
                  showAction: false,
                  backgroundColor: "#F44336",
                  actionTextColor: "#FFF"
                });
              }
            },
            response => {
              Snackbar.show({
                text: "No se pudo establecer conexión con el servidor.",
                actionText: "Cerrar",
                pos: "top-right",
                showAction: false,
                backgroundColor: "#F44336",
                actionTextColor: "#FFF"
              });
            }
          );
      }
    },
    validarCamposContrato() {
      !this.contrato.titulo_cnt
        ? (this.val.v_titulo = true)
        : (this.val.v_titulo = false);
      this.contrato.contenido_cnt === ""
        ? (this.val.v_contenido = true)
        : (this.val.v_contenido = false);
      !this.contrato.tipo_cnt
        ? (this.val.v_tipo = true)
        : (this.val.v_tipo = false);
      !this.contrato.duracion_cnt
        ? (this.val.v_duracion = true)
        : (this.val.v_duracion = false);
      if (
        this.val.v_titulo ||
        this.val.v_contenido ||
        this.val.v_tipo ||
        this.val.v_duracion
      ) {
        Snackbar.show({
          text: "Por favor llene todos los campos marcados con *",
          actionText: "Cerrar",
          pos: "top-right",
          showAction: false,
          backgroundColor: "#F44336",
          actionTextColor: "#FFF"
        });
        return false;
      } else {
        return true;
      }
    }
  },
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$router.push("/login");
    }
  },
  data() {
    return {
      msg: "ContratosNuevo",
      contrato: {
        titulo_cnt: null,
        contenido_cnt: "",
        tipo_cnt: null,
        duracion_cnt: null
      },
      val: {
        v_titulo: null,
        v_contenido: null,
        v_tipo: null,
        v_duracion: null
      }
    };
  }
};
</script>


// WEBPACK FOOTER //
// ContratosNuevo.vue?01b1a564